import React, { useEffect, useState } from 'react';
import { toast } from 'sonner';
import { BookMarked, Trash2 } from 'lucide-react';
import { useAuth } from '../../context/AuthContext';

const KIND = { respuesta_oficio: 'Respuesta a oficio', defensa_denuncia: 'Defensa ante denuncia', descargos: 'Descargos' };

// Biblioteca de Oficios: winning answers Fidem reuses before the same fiscal
export const OficioLibrary = () => {
  const { api } = useAuth();
  const [items, setItems] = useState(null);
  const load = () => api.get('/courts/library').then((r) => setItems(r.data.items)).catch(() => setItems([]));
  useEffect(() => { load(); }, []); // eslint-disable-line react-hooks/exhaustive-deps
  const del = async (id) => {
    try { await api.delete(`/courts/library/${id}`); toast.success('Eliminada de la Biblioteca'); load(); } catch { toast.error('No se pudo eliminar'); }
  };
  if (!items) return null;
  return (
    <div data-testid="oficio-library" className="mt-6 space-y-2">
      <p className="text-xs text-slate-400"><BookMarked className="mr-1 inline h-3.5 w-3.5 text-amber-400" />Respuestas que funcionaron. Se guardan solas al cerrar la causa como ganada, o con «Funcionó» en el escrito. Fidem las reutiliza ante el mismo fiscal o Corte. Solo tú las ves.</p>
      {!items.length && <p data-testid="oficio-library-empty" className="rounded-2xl border border-slate-800 p-6 text-sm text-slate-400">Aún no hay respuestas guardadas.</p>}
      {items.map((x) => (
        <div key={x.id} data-testid={`oficio-item-${x.id}`} className="flex items-start gap-3 rounded-xl border border-slate-800 bg-slate-900/40 p-3">
          <div className="min-w-0 flex-1">
            <p className="text-sm text-white">{x.title}</p>
            <p className="text-[11px] text-slate-500">{KIND[x.kind]}{x.respondent_kind ? ` · ${x.respondent_kind === 'cbr' ? 'Conservador' : 'Notario'}` : ''} · {x.fiscal_name || x.court_name || 'sin fiscal'} · {x.source === 'auto' ? 'causa ganada' : 'marcada por ti'} · {new Date(x.created_at).toLocaleDateString('es-CL')}</p>
            {x.suma && <p className="mt-1 line-clamp-2 text-xs text-slate-400">{x.suma}</p>}
          </div>
          <button data-testid={`oficio-delete-${x.id}`} onClick={() => del(x.id)} aria-label="Eliminar" className="rounded-full p-1.5 text-slate-500 hover:text-rose-300"><Trash2 className="h-3.5 w-3.5" /></button>
        </div>
      ))}
    </div>
  );
};
